import { defineMessages } from "react-intl";

const messages = defineMessages({
  drillDownSubtitle: {
    id: "dashboard.cards.outOfFrequency.drillDown.subTitle",
    defaultMessage: "Calculated every 30 minutes",
    description:
      "Subtitle of the DrillDown modal of the Out Of Frequency card on the Dashboard page",
  },
  listSubtitle: {
    id: "dashboard.cards.outOfFrequency.listSubtitle",
    defaultMessage: "{count} {count, plural, one {record} other {records}}",
    description: "List subtitle of the Out Of Frequency card on the Dashboard page",
  },
  mapSubtitle: {
    id: "dashboard.cards.outOfFrequency.mapSubtitle",
    defaultMessage: "{count}/{totalCount} {totalCount, plural, one {record} other {records}}",
    description: "Map subtitle of the Out Of Frequency card on the Dashboard page",
  },
  pastDue: {
    id: "dashboard.cards.outOfFrequency.pastDue",
    defaultMessage: "{days} {days, plural, one {day past due} other {days past due}}",
    description:
      "N Days past due label in list view on the Out Of Frequency card on the Dashboard page",
  },
});

export default messages;
